module.exports = __webpack_public_path__ + "img/partner07.1f1eca2f.png";